export default __webpack_public_path__ + "static/public/config/app.yml";